import script from "./AddSubkontraktorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AddSubkontraktorPage.vue?vue&type=script&setup=true&lang=js"

import "./AddSubkontraktorPage.vue?vue&type=style&index=0&id=eac3724c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eac3724c"]])

export default __exports__